export default __webpack_public_path__ + "static/media/toc-pajakku.3000daf3.md";